'use client'

import { useEffect } from 'react'
import Cookies from 'js-cookie'

import { useLocaleStore } from '@rewardops/ui'
import { localeFromLocaleStr } from '@rewardops/utils'

import { fireAirCanadaLocaleChangeEvent } from '~/custom/air-canada/events/fire-air-canada-main-header-event'
import { useApi } from './hooks/use-api'

interface LocaleSetterProps {
  localeStr: string
}

const LocaleSetter = ({ localeStr }: LocaleSetterProps) => {
  const { locale, setLocale } = useLocaleStore((state) => state)
  const newLocale = localeFromLocaleStr(localeStr)
  const { tenant } = useApi()

  useEffect(() => {
    if (!newLocale) {
      return
    }

    if (newLocale.locale !== locale.locale) {
      // If the locale has changed, fire the Air Canada locale change event
      if (locale.locale.length > 0) {
        fireAirCanadaLocaleChangeEvent({
          tenant,
          language: newLocale.language ?? tenant.locale.default,
        })
      }

      setLocale(newLocale)

      // Hard reload the page to ensure the locale change is reflected throughout the app (including the server-side rendered content)
      // window.location.reload()
    }
  }, [newLocale, locale, setLocale])

  Cookies.set('NEXT_LOCALE', localeStr)
  return undefined
}

interface LanguageSetterProps {
  language: string
}

const LanguageSetter = ({ language }: LanguageSetterProps) => {
  const { locale } = useLocaleStore()
  return <LocaleSetter localeStr={`${language}-${locale.country}`} />
}

export { LocaleSetter, LanguageSetter }
